import { demoDoc, contentBBox, connectorGeometry, rectOf } from '@scribbleplot/shared';

const doc = demoDoc();
const bounds = contentBBox(doc)!;
/** Static, bundled presentation of the real demo; no editor or network work. */
export function DemoPreview() {
  return (
    <div className="sp-demo-preview">
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 12,
          marginBottom: 18,
          fontSize: 12,
          color: '#b1b5c3',
        }}
      >
        <span>Nova website — redesign</span>
        <span>Moodboard → direction → layout</span>
      </div>
      <svg
        role="img"
        aria-label="A website design board with a moodboard, color palette, notes, and a connected layout"
        viewBox={`${bounds.x - 40} ${bounds.y - 60} ${bounds.w + 80} ${bounds.h + 100}`}
      >
        {doc.items.map((item) => (
          <g key={item.id}>
            {item.type === 'image' ? (
              <image
                href={item.src}
                x={item.x}
                y={item.y}
                width={item.w}
                height={item.h}
                preserveAspectRatio="xMidYMid slice"
              />
            ) : (
              <rect
                x={item.x}
                y={item.y}
                width={item.w}
                height={item.h}
                rx={item.type === 'sticky' ? 4 : 12}
                fill={item.type === 'sticky' ? item.color : item.type === 'frame' ? 'none' : '#292c34'}
                stroke={item.type === 'frame' ? '#454954' : 'none'}
              />
            )}
            {item.type === 'frame' && (
              <text x={item.x} y={item.y - 15} fill="#b1b5c3" fontSize="22">
                {item.label}
              </text>
            )}
            {(item.type === 'sticky' || item.type === 'text') && (
              <text x={item.x + 12} y={item.y + 30} fill={item.type === 'sticky' ? '#262419' : '#e8e9ed'} fontSize="18">
                {item.text
                  .split(' ')
                  .reduce<string[]>((lines, word) => {
                    if (!lines.length || lines[lines.length - 1].length + word.length > Math.max(12, item.w / 10))
                      lines.push(word);
                    else lines[lines.length - 1] += ' ' + word;
                    return lines;
                  }, [])
                  .slice(0, 4)
                  .map((line, i) => (
                    <tspan key={i} x={item.x + 12} dy={i ? 24 : 0}>
                      {line}
                    </tspan>
                  ))}
              </text>
            )}
          </g>
        ))}
        {doc.conns.map((conn) => {
          const a = rectOf(conn.a, doc.items),
            b = rectOf(conn.b, doc.items);
          return a && b ? (
            <path key={conn.id} d={connectorGeometry(a, b).path} stroke="#a78bfa" strokeWidth="3" fill="none" />
          ) : null;
        })}
      </svg>
    </div>
  );
}
